import React from "react";
import "./Header.css";
import { CTA } from "./CTA";
import Me from "../../assets/me.png";
import HeaderSocial from "./HeaderSocial";
import TypeAnimation from "react-type-animation";

const Header = () => {
  return (
    <header>
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1>Krishan Kumar Safi</h1>
        {/* <h5 className="text-light">Full-Stack Web Developer</h5> */}
        <TypeAnimation
          className="text-light"
          cursor={true}
          sequence={["Full-Stack Web Developer", 2000, "Good Listener", 2000]}
          wrapper="h5"
          repeat={Infinity}
        />
        <CTA />
        <HeaderSocial />
        <div className="me">
          <img src={Me} alt="Krishan Kumar Safi"></img>
        </div>
        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
